// Real, live Google Maps — via Google's own keyless "Share > Embed a map"
// iframe endpoint (the same one Google Maps' own Share button generates for
// a single place or a route). No API key, no Cloud project, no billing —
// unlike the Maps JavaScript API, which requires all three. The trade-off is
// one query per iframe (one place, or one route) rather than many custom
// markers on a single interactive map.
//
// `place`/`origin`/`destination` MUST be "lat,lng" coordinate strings, not
// address text — the keyless embed's geocoder can't reliably resolve a
// fictional street address (it silently falls back to an "Open in Maps"
// card, or a blank zoomed-out world view for directions) but always
// resolves a raw coordinate pair.
function buildPlaceSrc(query) {
  return `https://www.google.com/maps?q=${encodeURIComponent(query)}&z=14&output=embed`;
}

function buildDirectionsSrc(origin, destination) {
  return `https://www.google.com/maps?saddr=${encodeURIComponent(origin)}&daddr=${encodeURIComponent(destination)}&output=embed`;
}

export default function GoogleMapEmbed({ place, directions, title = 'Map', className = '' }) {
  const src = directions
    ? buildDirectionsSrc(directions.origin, directions.destination)
    : buildPlaceSrc(place || 'Nigeria');

  return (
    <iframe
      key={src}
      title={title}
      src={src}
      className={`h-full w-full ${className}`}
      style={{ border: 0 }}
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    />
  );
}
